var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_show),expression:"is_show"}]},[(_vm.seconds_variety > 0)?_c('span',[_vm._v(" ("+_vm._s(_vm.show_minutes)+"分"+_vm._s(_vm.show_seconds)+"秒) ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }